import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import SmsOutlinedIcon from '@material-ui/icons/SmsOutlined';

const pageStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		width: '100%',
		minHeight: '80vh',
		flexDirection: 'column',
		alignItems: 'center',
	},
	header: {
		width: '100%',
		height: '15em',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundSize: 'cover',
		backgroundImage: props => props.headerImage ? `url(${props.headerImage})` : 'none',
		backgroundColor: props => !props.headerImage ? '#ccc' : 'none',
		backgroundPosition: 'center center',
		[theme.breakpoints.up('md')]: {
			height: '20em',
		}
	},
	smsHeader: {
		width: '100%',
		minHeight: '14em',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		position: 'relative',
		overflow: 'hidden',
		background: `linear-gradient(135deg, ${theme.palette.navy.darkest} 0%, ${theme.palette.navy.main} 48%, #3d5a80 100%)`,
		[theme.breakpoints.up('md')]: {
			minHeight: '18em',
		}
	},
	smsHeaderOverlay: {
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		backgroundImage: props => props.headerImage
			? `linear-gradient(105deg, rgba(29,33,43,0.88) 0%, rgba(52,59,77,0.72) 55%, rgba(83,144,205,0.45) 100%), url(${props.headerImage})`
			: 'none',
		backgroundSize: 'cover',
		backgroundPosition: 'center right',
		opacity: props => props.headerImage ? 1 : 0,
	},
	smsDecor: {
		position: 'absolute',
		borderRadius: '50%',
		background: 'rgba(83, 144, 205, 0.18)',
		pointerEvents: 'none',
	},
	smsDecorLarge: {
		width: 180,
		height: 180,
		right: '8%',
		top: '18%',
		[theme.breakpoints.down('sm')]: {
			right: '-4%',
			top: '10%',
			width: 120,
			height: 120,
		},
	},
	smsDecorSmall: {
		width: 90,
		height: 90,
		right: '22%',
		bottom: '12%',
		background: 'rgba(247, 247, 247, 0.08)',
		[theme.breakpoints.down('sm')]: {
			display: 'none',
		},
	},
	smsBubble: {
		position: 'absolute',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: 16,
		color: '#fff',
		pointerEvents: 'none',
		[theme.breakpoints.down('sm')]: {
			display: 'none',
		},
	},
	smsBubblePrimary: {
		width: 56,
		height: 44,
		right: '12%',
		top: '28%',
		background: theme.palette.primary.main,
		boxShadow: '0 8px 24px rgba(29, 33, 43, 0.25)',
		'&::after': {
			content: '""',
			position: 'absolute',
			left: 12,
			bottom: -8,
			borderWidth: '8px 8px 0 0',
			borderStyle: 'solid',
			borderColor: `${theme.palette.primary.main} transparent transparent transparent`,
		},
	},
	smsBubbleGhost: {
		width: 44,
		height: 34,
		right: '20%',
		bottom: '22%',
		background: 'rgba(247, 247, 247, 0.18)',
		'&::after': {
			content: '""',
			position: 'absolute',
			right: 10,
			bottom: -7,
			borderWidth: '7px 0 0 7px',
			borderStyle: 'solid',
			borderColor: 'rgba(247, 247, 247, 0.18) transparent transparent transparent',
		},
	},
	smsDots: {
		display: 'flex',
		'& span': {
			width: 6,
			height: 6,
			borderRadius: '50%',
			background: '#fff',
			margin: '0 2px',
			opacity: 0.9,
		},
	},
	smsHeaderContent: {
		position: 'relative',
		zIndex: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		textAlign: 'center',
		padding: '2.5rem 1.5rem',
	},
	smsHeroIcon: {
		width: 52,
		height: 52,
		borderRadius: '50%',
		background: theme.palette.primary.main,
		color: '#fff',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: '1.25rem',
		boxShadow: '0 6px 20px rgba(29, 33, 43, 0.3)',
		'& svg': {
			fontSize: 26,
		},
	},
	title: {
		fontSize: '2.5em',
		color: [theme.palette.common.white],
		textShadow: '2px 2px 2px black',
	},
	smsTitle: {
		margin: 0,
		fontSize: '2rem',
		fontWeight: 900,
		color: theme.palette.common.white,
		letterSpacing: '-0.01em',
		textShadow: '0 2px 12px rgba(0,0,0,0.35)',
		[theme.breakpoints.up('md')]: {
			fontSize: '2.75rem',
		},
	},
	smsAccent: {
		width: 56,
		height: 3,
		background: theme.palette.primary.main,
		borderRadius: 2,
		marginTop: '1rem',
	},
	container: {
		width: '90%',
		padding: '4rem 0',
		[theme.breakpoints.up('md')]: {
			width: '60%'
		}
	},
	smsContainer: {
		width: '92%',
		padding: '3rem 0 4.5rem',
		[theme.breakpoints.up('md')]: {
			width: '70%',
			maxWidth: 820,
		}
	}
}))

export default function Page(props) {
	const classes = pageStyles(props);
	const isSms = props.variant === 'sms';

	return (
		<div className={classes.root}>
			{isSms ? (
				<div className={classes.smsHeader}>
					<div className={classes.smsHeaderOverlay} />
					<div className={`${classes.smsDecor} ${classes.smsDecorLarge}`} />
					<div className={`${classes.smsDecor} ${classes.smsDecorSmall}`} />
					<div className={`${classes.smsBubble} ${classes.smsBubblePrimary}`}>
						<span className={classes.smsDots} aria-hidden="true">
							<span /><span /><span />
						</span>
					</div>
					<div className={`${classes.smsBubble} ${classes.smsBubbleGhost}`} aria-hidden="true" />
					<div className={classes.smsHeaderContent}>
						<div className={classes.smsHeroIcon} aria-hidden="true">
							{props.headerIcon || <SmsOutlinedIcon />}
						</div>
						<h1 className={classes.smsTitle}>{props.title}</h1>
						<span className={classes.smsAccent} aria-hidden="true" />
					</div>
				</div>
			) : (
				<div className={classes.header}>
					<h1 className={classes.title}>{props.title}</h1>
				</div>
			)}
			<div className={isSms ? classes.smsContainer : classes.container}>
				{props.content}
			</div>
		</div>
	)
}
